import AppRoutes from "../routes/routes";
import { ToastContainer } from "react-toastify";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import {
  setAuthChecked,
  setAuthenticated,
  logOut,
} from "../redux/reducers/user.reducer";
import verifyToken from "../core/utilities/verifyToken";
function AppView() {
  const dispatch = useDispatch();

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (!token) {
      dispatch(setAuthenticated(false));
      dispatch(setAuthChecked(true));
      return;
    }

    const { Token } = verifyToken(token) || {};

    if (Token) {
      dispatch(setAuthenticated(true));
    } else {
      dispatch(logOut());
      dispatch(setAuthenticated(false));
    }

    dispatch(setAuthChecked(true));
  }, []);

  return (
    <div className="App">
      <AppRoutes />
      <ToastContainer />
    </div>
  );
}

export default AppView;
